export default __webpack_public_path__ + "static/desktop_menu_KV05-be67df841e107ed4bba0fa3357ddc4ac.mp4";